import React from "react";

export default function Header() {
  return (
    <header>
      {" "}
      <h1 className="title">QuizzTime</h1>
    </header>
  );
}
